import { logger } from './../constants';
import { getCLS, getFID, getLCP } from 'web-vitals';

function pushData({name, delta, id, value}) {
  const data = {
      event: "coreWebVitals",
      webVitalsMeasurement: {
        name,
        id,
        value: Math.round(name === 'CLS' ? value * 1000 : value),
        delta: Math.round(name === 'CLS' ? delta * 1000 : delta)
    }
  }
  // eslint-disable-next-line no-console
  logger('## TagManager - push to dataLayer', data);
  window.dataLayer.push(data);
}

function initWebVitals() {
  getCLS(pushData);
  getFID(pushData);
  getLCP(pushData);
}

const WebVitalsManager = {
  init: initWebVitals
};

export default WebVitalsManager;
